// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"176":"projects","186":"company","245":"notfound","631":"contact","894":"services"}[chunkId] + "." + {"176":"51c9d2bd","186":"9647c851","245":"cbf6b3b3","631":"17574951","894":"6d87649b"}[chunkId] + ".js";
};